import { toggleItems } from "app/components/widget/widget-utilities/time-granularity";
import dayjs from "dayjs";
import combineConfigs from "pro-features/components/Chart/src/combineConfigs";
import noLegendConfig from "pro-features/components/Chart/src/configs/legend/noLegendConfig";
import xAxisCrosshair from "pro-features/components/Chart/src/configs/xAxis/xAxisCrosshair";
import xAxisLabelsConfig from "pro-features/components/Chart/src/configs/xAxis/xAxisLabelsConfig";
import yAxisLabelsConfig from "pro-features/components/Chart/src/configs/yAxis/yAxisLabelsConfig";
import ReactDOMServer from "react-dom/server";
import { colorsPalettes } from "@similarweb/styles";
import monthlyIntervalConfig from "pro-features/components/Chart/src/configs/granularity/monthlyIntervalConfig";
import { minVisitsAbbrFilter, percentageSignFilter } from "app/filters/ngFilters";
import { EMetricType } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/types";
import type { IOverlapOvertimeContext } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/context";
import { Tooltip } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/Tooltip";
import tooltipContainerConfig from "pro-features/components/Chart/src/configs/tooltip/tooltipContainerConfig";

export const getChartConfig = (overlapOvertimeContext: IOverlapOvertimeContext) => {
    const { selectedMetric, chartDataAll } = overlapOvertimeContext;
    const isChartStacking = false;
    const xAxisFormatter = ({ value }) => dayjs.utc(value).format(toggleItems.Monthly.format);
    const yAxisFormatter = ({ value }) =>
        selectedMetric === EMetricType.TOTAL ? minVisitsAbbrFilter()(value) : percentageSignFilter()(value, 2);
    const chartConfig = combineConfigs({ xAxisFormatter, yAxisFormatter }, [
        noLegendConfig,
        xAxisCrosshair,
        xAxisLabelsConfig,
        yAxisLabelsConfig,
        monthlyIntervalConfig,
        tooltipContainerConfig,
        {
            tooltip: {
                followPointer: false,
                shared: true,
                outside: true,
                useHTML: true,
                formatter: function () {
                    const hoverPoint = { x: this.x, y: this.y };
                    return ReactDOMServer.renderToString(
                        <Tooltip
                            hoverPoint={hoverPoint}
                            chartDataAll={chartDataAll}
                        />,
                    );
                },
            },
            chart: {
                height: 300,
                spacingTop: 10,
                plotBackgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "Roboto",
                },
            },
            plotOptions: {
                line: {
                    lineWidth: 2,
                    connectNulls: false,
                },
                area: {
                    stacking: "normal",
                },
                series: {
                    turboThreshold: 5000,
                    fillOpacity: 1,
                    marker: {
                        enabled: false,
                        symbol: "circle",
                    },
                    stacking: isChartStacking,
                    animation: false,
                },
            },
            yAxis: {
                gridLineWidth: 0.5,
                showFirstLabel: true,
                showLastLabel: true,
                reversed: false,
                gridZIndex: 2,
                reversedStacks: true,
                tickPixelInterval: 50,
                labels: {
                    style: {
                        textTransform: "uppercase",
                        fontSize: "11px",
                        fontFamily: "Roboto",
                        color: colorsPalettes.carbon[200],
                    },
                },
            },
            xAxis: {
                gridLineWidth: 0,
                gridLineDashStyle: "dash",
                tickLength: 5,
                labels: {
                    style: {
                        textTransform: "capitalize",
                        fontSize: "11px",
                        color: "#919191",
                        fontFamily: "Roboto",
                    },
                },
                minPadding: 0,
                maxPadding: 0,
            },
        },
    ]);
    return chartConfig;
};
